import { useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { downloadFile, formatErr } from "@/lib/api";

export function InvestorPdfButton() {
  const [busy, setBusy] = useState(false);
  const get = async (lang) => {
    setBusy(true);
    try { await downloadFile(`/admin/investor-overview.pdf?lang=${lang}`, `GrantVerify-Investor-Overview-${lang}.pdf`); toast.success("Investor overview downloaded with live results"); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" disabled={busy} data-testid="admin-investor-pdf-button">{busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <FileText className="h-4 w-4 mr-2" />}Investor PDF</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => get("en")} data-testid="admin-investor-pdf-en">English</DropdownMenuItem>
        <DropdownMenuItem onClick={() => get("es")} data-testid="admin-investor-pdf-es">Español</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
